import Loadable from "react-loadable";
import LoadingComponent from "../../commons/loader";

export default [
  {
    path: "/profile/:id",
    exact: true,
    auth: true,
    component: Loadable({
      loader: () => import("./pages"),
      loading: LoadingComponent
    })
  }
];



// WEBPACK FOOTER //
// ./src/modules/profile/routes.js